import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useFilters } from '../useFilters';
import Calendars from 'libs/api/admin/calendars';
import moment from 'moment';
import CalendarsEditAdapter from '../edit/edit-calendar.adapter';

const api = new Calendars();

const getDates = (date, groupBy) => ({
  by_date_from: moment(date).startOf(groupBy).format('YYYY-MM-DD'),
  by_date_to: moment(date).endOf(groupBy).format('YYYY-MM-DD'),
});

export const useViewCalendar = () => {
  const { id: date } = useParams();
  const [loading, setLoading] = useState(true);
  const [singleData, setSingleData] = useState([]);
  const { groupBy, backendFilters } = useFilters();

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const {
        data: { calendars },
      } = await api.list({
        params: {
          ...getDates(date, groupBy || 'day'),
        },
      });
      setSingleData(CalendarsEditAdapter(calendars || []));
    } catch (e) {
      setSingleData([]);
    } finally {
      setLoading(false);
    }
  }, [date, groupBy]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    singleData,
    loading,
    groupBy: groupBy || 'day',
    date,
    backendFilters,
  };
};
